import { render, staticRenderFns } from "./TitleTipsItem.vue?vue&type=template&id=78c05ab9&scoped=true"
import script from "./TitleTipsItem.vue?vue&type=script&lang=js"
export * from "./TitleTipsItem.vue?vue&type=script&lang=js"
import style0 from "./TitleTipsItem.vue?vue&type=style&index=0&id=78c05ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c05ab9",
  null
  
)

export default component.exports